module.exports = __webpack_public_path__ + "img/error.5af93e4f.png";